module.exports = __webpack_public_path__ + "static/tat-39-d72deca5570aeee71bb575a197b1f902.jpg";